// `/inbox/:id` — the triage view with the routed session selected.
//
// Same `<InboxTriage>` as `/inbox` (design 1e — selection IS the route
// param, so the queue stays visible next to the detail pane and a deep
// link lands with the right row highlighted).
//
// **Ownership stays fail-closed (R11, carried over from the previous
// `<SessionView>` page):** `InboxTriage` waits for BOTH `whoAmI` and the
// `runs.byId` row, and only renders the approve/deny buttons + the reply
// composer when the caller POSITIVELY owns the session — a row-fetch
// error or a foreign session renders read-only with a pointer at the
// firm-wide /approvals page. Deep links survive the login redirect via
// the existing `AuthGate` mechanism (`state.from` threading — app.tsx).

import { useParams } from 'react-router-dom';

import { InboxTriage } from './triage.js';

export function InboxSessionPage(): React.ReactElement {
  const params = useParams<{ id: string }>();
  const sessionId = params.id ?? '';

  if (sessionId.length === 0) {
    return (
      <section className="page-inbox-detail" role="alert">
        <h1>Not found</h1>
        <p>No session id in the URL.</p>
      </section>
    );
  }

  return <InboxTriage selectedSessionId={sessionId} />;
}
